import { DOCUMENT_TYPE } from '@mos-front-components/public/es/components/Passport/private/constants';

const numberMask = documentType => {
  switch (documentType) {
    case DOCUMENT_TYPE.MILITARY_ID:
      return {
        regex: '[А-Яа-я]{2} \\d{7}'
      };
    case DOCUMENT_TYPE.OFFICER_ID:
      return {
        regex: '[А-Яа-я]{2} \\d{6}'
      };
    case DOCUMENT_TYPE.SEAMAN_PASSPORT_RF:
      return {
        regex: '[IVXLCDM]{2} \\d{7}'
      };
    default:
      return {
        regex: '[А-Яа-яA-Za-z0-9-]{0,20}'
      };
  }
};

export default numberMask;
